function printPath(renderer, attrs, params) {
	var ret = renderer.paper.path(attrs);

	return ret;
}

module.exports = printPath;
